import React from "react";
import { LegalPage } from "@/components/LegalPage";

export const TermsOfServicePage: React.FC = () => (
  <LegalPage
    title="Terms of Service"
    lastUpdated="September 16, 2026"
    intro='These Terms of Service ("Terms") govern your use of the Feingold Property Management, LLC ("Feingold", "we", "us") website and services. By accessing or using this website, you agree to these Terms. If you do not agree, please discontinue use of the site.'
    sections={[
      {
        heading: "Use of Website",
        body: (
          <p>
            You may use this website for lawful purposes only. You agree not to
            misuse the site, attempt to gain unauthorized access, introduce
            malicious code, or use it in a manner that could damage, disable, or
            impair the site or interfere with any other party's use.
          </p>
        ),
      },
      {
        heading: "Services",
        body: (
          <p>
            Information on this website describes Feingold's property management
            services and is provided for general informational purposes. Service
            availability, pricing, and terms are subject to a written management
            agreement. Nothing on this site constitutes a binding offer or
            commitment until set forth in a signed agreement.
          </p>
        ),
      },
      {
        heading: "No Professional Advice",
        body: (
          <p>
            Content on this website, including calculators and financial tools,
            is provided for estimation and informational purposes only and does
            not constitute legal, tax, investment, or real estate advice. You
            should consult appropriate professionals before making decisions
            based on this information.
          </p>
        ),
      },
      {
        heading: "Intellectual Property",
        body: (
          <p>
            All content on this website, including text, graphics, logos, and
            design, is the property of Feingold Property Management, LLC or its
            licensors and is protected by intellectual property laws. You may
            not reproduce, distribute, or create derivative works without our
            prior written permission.
          </p>
        ),
      },
      {
        heading: "Third-Party Links & Content",
        body: (
          <p>
            This website may contain links to third-party websites and embedded
            third-party content. Feingold is not responsible for the content,
            accuracy, or practices of any third-party site and disclaims
            liability for such content.
          </p>
        ),
      },
      {
        heading: "Limitation of Liability",
        body: (
          <p>
            To the fullest extent permitted by law, Feingold shall not be liable
            for any indirect, incidental, special, or consequential damages
            arising from your use of, or inability to use, this website or
            services.
          </p>
        ),
      },
      {
        heading: "Changes to Terms",
        body: (
          <p>
            We may revise these Terms at any time. Updated Terms will be posted
            on this page with a revised date. Your continued use of the site
            after changes constitutes acceptance of the revised Terms.
          </p>
        ),
      },
    ]}
  />
);
